<template>
    <div>

        <vue-headful title="Equipment Email Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link to="/equipment">
                        <i class="fa fa-truck"></i> Equipment
                    </router-link>
                </li>
                 <li class="breadcrumb-item font-weight-light">
                    <router-link to="/equipment#types">
                        Types
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/equipment/types/view/${alert.equipment_type_id}`">
                        {{ alert.equipment_type.equipment_type_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">Email Alert<template v-if="!loading">: {{ alert.alert_name }}</template></li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-4 col-12 mb-lg-0 mb-3">
                    <div class="card">
                        <div class="card-header">
                            Alert Details
                            <span class="pull-right">
                                <router-link :to="`/admin/equipment-alerts/edit/${alert.id}`" title="Edit Email Alert" class="btn btn-sm btn-secondary">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/admin/equipment-alerts/delete/${alert.id}`" title="Delete Email Alert" class="btn btn-sm btn-danger">
                                    <i class="fa fa-trash"></i> Delete
                                </router-link>
                            </span>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Alert Name:</div>
                                <div class="col-md-8">{{ alert.alert_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Description:</div>
                                <div class="col-md-8">{{ alert.description }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Active:</div>
                                <div class="col-md-8">
                                    <label v-if="alert.is_active == 1" class="badge badge-success">Active</label>
                                    <label v-if="alert.is_active == 0" class="badge badge-warning">Inactive</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-lg-8 col-12">
                    <div class="card">
                        <div class="card-header">Conditions</div>
                        <div class="card-body">
                            <li v-for="(cond, key) in conditions">
                                <strong>WHEN </strong>{{cond.field_type}} "{{cond.field_value_formatted}}"<strong> IS </strong>{{cond.cond_value_formatted}}<strong> DAYS </strong>{{cond.cond_sign}}
                            </li>
                        </div>
                    </div>

                    <div class="card mt-3">
                        <div class="card-header">Recipients Rules</div>
                        <div class="card-body">
                            <strong>Send Email To:</strong>
                            <ol>
                                <li v-for="(recip, key) in recipients">
                                    {{ recip.target_type }} -
                                    <template v-if="recip.target_type == 'Employee' || recip.target_type == 'User'">
                                        {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}
                                        <template v-if="recip.target_label.email"><a :href="`mailto:${recip.target_label.email}`">{{ recip.target_label.email }}</a></template>
                                        <template v-else-if="recip.target_label.Email"><a :href="`mailto:${recip.target_label.Email}`">{{ recip.target_label.Email }}</a></template>
                                        <template v-else>(No Email on Record)</template>
                                    </template>
                                    <template v-else>{{ recip.target_label }}</template>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="card mt-3">
                        <div class="card-header"><strong>Based on the Recipient Rules, Here are the Target Email Addresses:</strong></div>
                        <div class="card-body">
                            <ol>
                                <li v-for="(email, key) in emails">
                                    <a :href="`mailto:${email}`">{{ email }}</a>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                errors: {},
                alert: {},
                conditions: [],
                recipients: [],
                emails: [],
            }
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('admin/equipment-alerts/view/' + this.id)
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;
                        this.conditions = this.alert.conditions;
                        this.recipients = this.alert.recipients;

                        //Emails
                        this.emails = res.data.emails;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
